import { useMemo } from "react";
import { GenerateReinspecaoEmAbertoColumnDefinition } from "../columns/reinspecao_em_aberto";
import { Dialog, DialogActions, DialogContent, DialogTitle, TablePagination } from "@mui/material";
import { StyledDataGrid } from "../../../../../../common/components/styled_data_grid";
import { ReinspecaoEmAbertoLista } from "../../../../domain/models/reinspecao_em_aberto";
import { PaginationProperties, SetPaginationProperties } from "../../../../../../common/utils/pagination_property";
import { DefaultMultiAutocomplete } from "../../../../../../common/components/default_multi_autocomplete";
import { ChecklistServicoDropDown } from "../../../../domain/models/checklist_servico_dropdown";

import CascateList from "../../../../../../common/components/cascate_list";
import DefaultInput from "../../../../../../common/components/default_input";
import PrimaryButton from "../../../../../../common/components/primary_button";

type Props = {
    open: boolean;
    loading: boolean;
    lista: ReinspecaoEmAbertoLista[];
    checklists: ChecklistServicoDropDown[],
    idsObraChecklistServicos?: number[];
    area: string;
    pagination: PaginationProperties & SetPaginationProperties;
    onChecklistServicoChange: (idsChecklistServico: number[]) => void;
    onObraAreaChecklistChange: (area: string) => void;
    onClearFilters: () => void;
    onPageChange: (page: number) => void;
    onRowsPerPageChange: (rowsPerPage: number) => void;
    onClose: () => void;
    onRedirectToReinspecaoEmAberto: (idObra: number, idChecklistServico: number, idChecklistArea: number, idInspecaoObra: number, openNewTab: boolean) => void;
};

export const ReinspecaoEmAbertoModal = ({
    open,
    loading,
    lista,
    checklists,
    idsObraChecklistServicos,
    area,
    pagination,
    onChecklistServicoChange,
    onObraAreaChecklistChange,
    onClearFilters,
    onClose,
    onRedirectToReinspecaoEmAberto,
    onPageChange,
    onRowsPerPageChange,

}: Props) => {

    const columnDefinition = useMemo(() => {
        return GenerateReinspecaoEmAbertoColumnDefinition({
            onRedirectToReinspecaoEmAberto
        });
    }, [
        onRedirectToReinspecaoEmAberto,
    ]);

    return (
        <Dialog
            open={open}
            onClose={onClose}
            sx={{
                "& .MuiDialog-container": {
                    "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "80rem",
                    },
                },
            }}>

            <DialogTitle>
                Serviço para reeinspeção
            </DialogTitle>

            <CascateList
                title="Filtros"
                defaultOpen>
                <div className="w-full flex flex-col gap-6 items-center justify-center">
                    <div className="w-full flex flex-row gap-3 justify-between">
                        <div className="w-full">
                            <DefaultInput
                                name='area'
                                label='Área'
                                readOnly={false}
                                value={area ?? ""}
                                onChangeValue={onObraAreaChecklistChange} />
                        </div>

                        <div className="w-full">
                            <DefaultMultiAutocomplete
                                label='Checklist Servico'
                                value={checklists.filter(x => idsObraChecklistServicos?.includes(x.idChecklistServico) ?? false)}
                                options={checklists}
                                getOptionLabel={x => x.descricao}
                                getOptionKey={x => x.idChecklistServico}
                                onChange={x => onChecklistServicoChange(x?.map(y => y.idChecklistServico) ?? [])}
                            />
                        </div>

                        <div className="w-full flex justify-end p-4">
                            <PrimaryButton
                                className="p-2 bg-red-500 text-white rounded"
                                buttonColor="yellow"
                                onClick={onClearFilters}>
                                Limpar Filtros
                            </PrimaryButton>
                        </div>
                    </div>
                </div>
            </CascateList>

            <DialogContent>
                <div className="w-full">
                    <StyledDataGrid
                        tableName="change_history_modal"
                        disableColumnMenu={false}
                        getRowId={(r: ReinspecaoEmAbertoLista) => r.idInspecaoItem}
                        columns={columnDefinition}
                        loading={loading}
                        rows={lista}
                        rowCount={lista.length}
                        pageSizeOptions={[100]}
                        paginationMode="server"
                        getRowHeight={() => 'auto'}
                        paginationModel={{
                            page: pagination.page - 1,
                            pageSize: pagination.rowsPerPage,
                        }} />

                    <TablePagination
                        component="div"
                        count={pagination.totalItems}
                        page={pagination.page - 1}
                        rowsPerPageOptions={[100]}
                        onPageChange={(_, p) => onPageChange(p)}
                        rowsPerPage={pagination.rowsPerPage}
                        onRowsPerPageChange={(e) => onRowsPerPageChange(parseInt(e.target.value))} />

                </div>


            </DialogContent>

            <DialogActions>
                <div className="w-full h-full items-center justify-end flex p-4 gap-4">
                    <div className="flex flex-row gap-2">
                        <div className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
                            <h1
                                className="text-sm text-black dark:text-white"
                                onClick={() => onClose()}>
                                Fechar
                            </h1>
                        </div>
                    </div>
                </div>
            </DialogActions>
        </Dialog>
    );
}